import { IconX } from "@tabler/icons-react";
import s from "../partnerPortal.module.css";
import { STATUS_CLASS } from "../portalData";

export function Panel({ children, flush, sunken, className = "", style }) {
  return (
    <div
      className={`${s.panel} ${flush ? s.panelFlush : ""} ${sunken ? s.panelSunken : ""} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ title, sub }) {
  return (
    <div className={s.sectionTitle}>
      <div className={s.sectionTitleText}>{title}</div>
      {sub && <div className={s.sectionSub}>{sub}</div>}
    </div>
  );
}

export function Pill({ status }) {
  return (
    <span className={`${s.pill} ${s[STATUS_CLASS[status]] || s.pillPending}`}>
      {String(status || "").replace("_", " ")}
    </span>
  );
}

export function Modal({ open, onClose, children, maxWidth }) {
  if (!open) return null;
  return (
    <div className={s.overlay} onClick={onClose}>
      <div
        className={s.modal}
        style={maxWidth ? { maxWidth } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export function ModalClose({ onClose }) {
  return (
    <button type="button" className={s.modalClose} onClick={onClose} aria-label="Close">
      <IconX size={17} />
    </button>
  );
}
